setInterval(function(){
  if(jQuery('.drawer-menu').hasClass('active')){
   jQuery('header').addClass('drawer-open');
  }
  else{
    jQuery('header').removeClass('drawer-open');
  }
}, 50);

jQuery(document).ready(function(){  
  const $menuProduct = $('.navigation-product-section .menu-product');
  if($menuProduct) {
    let breakPC = window.matchMedia("only screen and (min-width: 961px)");
    if(breakPC.matches) {
      let maxHeightEl = 280;
      $menuProduct.each(function() {
        $(this).find('.navigation-product-section .menu-product').each(function(){
          if($(this).height() > max)
          maxHeightEl = $(this).height();
        });
        const headerLinksMenu = document.querySelectorAll('.header__links');
        headerLinksMenu.forEach(item => {
          item.style = `--menuProductHeight: ${maxHeightEl + 25}px; --menuProductHeightVal: ${maxHeightEl }px`;
        })
      })
    }
  }

 if(jQuery('body').hasClass('layout-page-experiences')) {
jQuery('body').addClass('transparent');    
 }

 if(jQuery('body').hasClass('template-article')) {
jQuery('body').addClass('transparent');    
 }


 jQuery('header button.navigation__submenu-trigger.no-transition').hover(function(){
  jQuery(this).parent().toggleClass('col-clicked');
  jQuery('.navigation__submenu').removeClass('col-clicked');
  jQuery(this).parent().find('.navigation__submenu').addClass('col-clicked');
  bodyTag.toggleClass('bcol-clicked');
});  

jQuery('.navigation__submenu').on('mouseleave', function() {
  jQuery(this).removeClass('col-clicked');
});

jQuery('.header__links-list > li > a[data-link]').on('mouseenter', function() {
  jQuery('.navigation__submenu').removeClass('col-clicked');
});

jQuery('.navigation-list-container.Collections .navigation__submenu-item').mouseenter(function(){

 var i = parseInt(jQuery(this).index()) - 1;
 jQuery('.navigation-list-container.Collections + .navigation-product-section .menu-product-container').removeClass('hovered');
 jQuery('.navigation-list-container.Collections + .navigation-product-section .menu-product-container').eq(i).addClass('hovered');
}); 

jQuery('.navigation__submenu-item').mouseenter(function(){

 var i = parseInt(jQuery(this).index()) - 1;

 jQuery('.navigation-list-container:not(.Collections) + .navigation-product-section .menu-product-container').removeClass('hovered');
 jQuery('.navigation-list-container:not(.Collections) + .navigation-product-section .menu-product-container').eq(i).addClass('hovered');
});   


jQuery('.header-sticky .navigation-list-container.Collections .navigation__submenu-item').mouseenter(function(){

 var i = parseInt(jQuery(this).index()) - 1;
 jQuery('.header-sticky .navigation-list-container.Collections + .navigation-product-section .menu-product-container').removeClass('hovered');
 jQuery('.header-sticky .navigation-list-container.Collections + .navigation-product-section .menu-product-container').eq(i).addClass('hovered');
});  

jQuery('.header-sticky .navigation__submenu-item').mouseenter(function(){

 var i = parseInt(jQuery(this).index()) - 1;
 jQuery('.header-sticky .navigation-list-container:not(.Collections) + .navigation-product-section .menu-product-container').removeClass('hovered');
 jQuery('.header-sticky .navigation-list-container:not(.Collections) + .navigation-product-section .menu-product-container').eq(i).addClass('hovered');
});   
 jQuery('.drawer-menu__list--sub .drawer-menu__item:not(.collection-all-li) > a').click(function(e){

 e.preventDefault();
 e.stopPropagation();
   e.stopImmediatePropagation();
 jQuery(this).parent().toggleClass('drop-down');
}); 
var headerSearch = jQuery('.header_search');
if(headerSearch) {
  headerSearch.each(function() {
    jQuery(this).click(function(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      jQuery('.quick-search').addClass('active visible');
      jQuery('body').addClass('search-open');
    });
  })
}

jQuery('.quick-search  .quick-search__close').click(function(e){
  jQuery('.quick-search').removeClass('active visible');
 jQuery('body').removeClass('search-open');
});

jQuery('.drawer-menu-sticky a.drawer-menu__link').click(function(e){
 const link = e.currentTarget;
 const childMenu = link.nextElementSibling;
 const depth = jQuery(link).closest('[data-depth]');
 jQuery(childMenu).addClass('visible');
 jQuery(link.parentNode).addClass('child-visible');

 if (childMenu.hasAttribute('data-search-menu')) {
   jQuery(link).closest('[data-drawer-menu]').addClass('search-active');
 }

 jQuery(link).closest('[data-main]').css('height', childMenu.offsetHeight +  8 + 'px');
 depth.data('depth', (depth.data('depth') + 1));
 link.setAttribute('aria-expanded', true);
 childMenu.setAttribute('aria-hidden', false);
 setTimeout(() => {
   jQuery(link).focus();
 }, 50);
});

 jQuery('.drawer-menu-sticky .drawer-menu__search-parent [data-item="back"]').click(function(e){
   const link = e.currentTarget;
   const menuBefore = link.closest('[data-list-item]').closest('ul');
   const firstFocusable = jQuery(menuBefore).find('.drawer-menu__link');
   const menu = link.closest('ul');
   const parentLink = jQuery(menu.parentNode).find('.drawer-menu__link');
   const depth = jQuery(link).closest('[data-depth]');
   jQuery(menu).removeClass('visible');
   jQuery(parentLink.parentNode).removeClass('child-visible');
   depth.data('depth', (depth.data('depth') - 1));
   parentLink.setAttribute('aria-expanded', false);
   menu.setAttribute('aria-hidden', true);
   jQuery(link).closest('[data-main]').css('height', menuBefore.offsetHeight +  8 + 'px');

   if (menu.hasAttribute('data-search-menu')) {
     jQuery(link).closest('[data-drawer-menu]').removeClass('search-active');
   }

  setTimeout(() => {
    firstFocusable.focus();
  }, 50);

  const $menuToggleSticky = $('#shopify-section-header-sticky .header__menu-icon');
   if($menuToggleSticky) {
     $menuToggleSticky.click();
   }

});
});

const $snizeMobile = $('.snize-ac-results-mobile .snize-close-button-arrow');
if($snizeMobile) {
 jQuery('body').on('click','.snize-ac-results-mobile .snize-close-button-arrow', function(e){
   document.querySelector('.header-sticky').style.display = 'block';
 });
}

/* WHITE HEADER FIX */
window.addEventListener('load', () => {
  const mainHdr = document.querySelector('[data-section-id=header]');
  const cookieButtons = document.querySelectorAll('.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-pc-btn-handler');
  if(mainHdr) {
    const headerH = parseInt(mainHdr.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--height-header', `${headerH}px`);
   
    setTimeout(() => {
      if(cookieButtons) {
          cookieButtons.forEach((item) => {
          item.addEventListener('click', () => {
              document.documentElement.style.setProperty('--height-header', `${headerH}px`);
          })
        })
      }
      }, 300)
    }
})